import { LoadingShimmer, constants } from "@newsela/angelou";

const { ui } = constants.colors;

const PercentageBarLoadingShimmer = () => {
  return (
    <LoadingShimmer
      backgroundColor={ui.core[100]}
      shimmerColor={ui.core[700]}
    />
  );
};
export default PercentageBarLoadingShimmer;
